const compareSimilarUrls = (url1, url2, urlPrefixPartToRemove = '/api') => {
    // Checking params value
    if (!url1 || typeof (url1) !== 'string' ||
        !url2 || typeof (url2) !== 'string' ||
        urlPrefixPartToRemove && typeof (urlPrefixPartToRemove) !== 'string') {
        return null;
    }

    // Removing '/api' part or specific prefix part
    if (url1.includes(urlPrefixPartToRemove)) {
        url1 = url1.split(urlPrefixPartToRemove)[1];
    }
    if (url2.includes(urlPrefixPartToRemove)) {
        url2 = url2.split(urlPrefixPartToRemove)[1];
    }

    // Initialising variables
    let isSimilar = false;
    const url1Parts = url1.split('/');
    const url2Parts = url2.split('/');

    // Checking url parts length
    if (url1Parts.length !== url2Parts.length) {
        return null;
    }

    // Processing
    for (let i = 0; i < url1Parts.length; i++) {
        if (!url1Parts[i].includes(':') && !url2Parts[i].includes(':')) {
            isSimilar = url1Parts[i] === url2Parts[i];
        }
    }

    return isSimilar;
};

export default compareSimilarUrls;